export const ACTIVE_TEAM_STORAGE_KEY = 'ff_active_team_id'
export const PERSONAL_WORKSPACE_ID = 'personal_default'

export function normalizeTeamId(value: string | null | undefined): string | null {
  const normalized = String(value || '').trim()
  if (!normalized || normalized === PERSONAL_WORKSPACE_ID) {
    return null
  }
  return normalized
}

export function getStoredActiveTeamId(): string | null {
  if (typeof window === 'undefined') return null
  try {
    // URL team_id is the source of truth for request scoping.
    const urlTeamId = normalizeTeamId(new URL(window.location.href).searchParams.get('team_id'))
    if (urlTeamId) {
      return urlTeamId
    }
    return null
  } catch {
    return null
  }
}

export function getPersistedActiveTeamId(): string | null {
  if (typeof window === 'undefined') return null
  try {
    return normalizeTeamId(window.localStorage.getItem(ACTIVE_TEAM_STORAGE_KEY))
  } catch {
    return null
  }
}

function serializeLikeInput(input: string, parsed: URL): string {
  if (/^https?:\/\//i.test(input)) return parsed.toString()
  return `${parsed.pathname}${parsed.search}${parsed.hash}`
}

export function appendWorkspaceScopeToUrl(input: string, teamId: string | null): string {
  try {
    const base = typeof window !== 'undefined' ? window.location.origin : 'http://localhost'
    const parsed = new URL(input, base)
    const path = parsed.pathname || ''
    if (!path.startsWith('/v1/')) {
      return input
    }

    const normalizedTeamId = normalizeTeamId(teamId)
    if (normalizedTeamId) {
      if (!parsed.searchParams.get('team_id')) {
        parsed.searchParams.set('team_id', normalizedTeamId)
      }
    } else {
      parsed.searchParams.delete('team_id')
    }
    return serializeLikeInput(input, parsed)
  } catch {
    return input
  }
}

export function appendWorkspaceScopeToPath(path: string, teamId: string | null): string {
  try {
    const base = typeof window !== 'undefined' ? window.location.origin : 'http://localhost'
    const parsed = new URL(path, base)
    const normalizedTeamId = normalizeTeamId(teamId)
    if (normalizedTeamId) {
      parsed.searchParams.set('team_id', normalizedTeamId)
    } else {
      parsed.searchParams.delete('team_id')
    }
    return `${parsed.pathname}${parsed.search}${parsed.hash}`
  } catch {
    return path
  }
}
